<template>
  <div :class="$style.container">
    <transition name="slide-left" mode="out-in">
      <component
        :is="currentSlide"
        v-hammer:swipe="onSwipe"
      />
    </transition>
    <div v-if="isShownIndicators" class="slider-indicators-container">
      <div
        v-for="(slide, idx) in slideList"
        :key="idx"
        class="slider-indicator"
        :class="{ active: currentIndex === idx }"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import MerchantService from 'services/merchant';

import TelegramInformationPanel from 'atoms/InformationPanels/TelegramInformationPanel';
import WidgetInformationPanel from 'atoms/InformationPanels/WidgetInformationPanel';
import ReportInformationPanel from 'atoms/InformationPanels/ReportInformationPanel';

export default {
  name: 'InformationSliding',
  components: {
    ReportInformationPanel,
    TelegramInformationPanel,
    WidgetInformationPanel,
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    slideList() {
      return [
        !this.isBotSigned && 'TelegramInformationPanel',
        'ReportInformationPanel',
        'WidgetInformationPanel',
      ].filter(i => i);
    },
    currentSlide() {
      return this.slideList[this.currentIndex];
    },
    isShownIndicators() {
      return this.slideList.length > 1;
    },
    isBotSigned() {
      return MerchantService.checkBotSigned(this.MERCHANT_INFO);
    },
    ...mapState([
      'MERCHANT_INFO',
    ]),
  },
  methods: {
    onSwipe() {
      const nextIndex = this.currentIndex + 1;

      if (this.$validate.isUndefined(this.slideList[nextIndex])) {
        this.currentIndex = 0;
        return;
      }

      this.currentIndex = nextIndex;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    overflow: hidden
</style>

<style lang="sass" scoped>
  .slider-indicators-container
    position: relative
    display: flex
    justify-content: center
    margin-top: 15px

  .slider-indicator
    width: 20px
    height: 5px
    border-radius: 20px
    background: #FFFFFF
    opacity: 0.2

    &.active
      background-color: #7CB342
      opacity: 1

    &:not(:last-child)
      margin-right: 10px
</style>
